// extracted by mini-css-extract-plugin
module.exports = {"nameText":"TraceCodeFlow_nameText__3NExf","productText":"TraceCodeFlow_productText__1c-rs"};